var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWalletMinus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6963 11.9985H6.94629",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49497 1.8886L9.47247 1.9411L7.29747 6.9886H5.15997C4.64997 6.9886 4.16247 7.0936 3.71997 7.2811L5.03247 4.1461L5.06247 4.0711L5.11497 3.9511C5.12997 3.9061 5.14497 3.8611 5.16747 3.8236C6.14997 1.5511 7.25997 1.0336 9.49497 1.8886Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5376 7.13867C13.2001 7.03367 12.8401 6.98867 12.4801 6.98867H7.29761L9.47261 1.94117L9.49511 1.88867C9.60761 1.92617 9.71261 1.97867 9.82511 2.02367L11.4826 2.72117C12.4051 3.10367 13.0501 3.50117 13.4401 3.98117C13.5151 4.07117 13.5751 4.15367 13.6276 4.25117C13.6951 4.35617 13.7476 4.46117 13.7776 4.57367C13.8076 4.64117 13.8301 4.70867 13.8451 4.76867C14.0476 5.39867 13.9276 6.17117 13.5376 7.13867Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1413 10.6488V12.1113C16.1413 12.2613 16.1338 12.4113 16.1263 12.5613C15.9838 15.1788 14.5213 16.4988 11.7463 16.4988H5.89629C5.71629 16.4988 5.53629 16.4838 5.36379 16.4613C2.97879 16.3038 1.70379 15.0288 1.54629 12.6438C1.52379 12.4713 1.50879 12.2913 1.50879 12.1113V10.6488C1.50879 9.14127 2.42379 7.84377 3.72879 7.28127C4.17879 7.09377 4.65879 6.98877 5.16879 6.98877H12.4888C12.8563 6.98877 13.2163 7.04127 13.5463 7.13877C15.0388 7.59627 16.1413 8.99127 16.1413 10.6488Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.0325 4.146L3.72 7.281C2.415 7.8435 1.5 9.141 1.5 10.6485V8.451C1.5 6.321 3.015 4.5435 5.0325 4.146Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1389 8.45074V10.6482C16.1389 8.99824 15.0439 7.59574 13.5439 7.14574C13.9339 6.17074 14.0464 5.40574 13.8589 4.76824C13.8439 4.70074 13.8214 4.63324 13.7914 4.57324C15.1864 5.29324 16.1389 6.77074 16.1389 8.45074Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletMinus);
export default __webpack_public_path__ + "static/media/wallet-minus.3c9e1cf9b9cfb423f0ee3c0e332e43e8.svg";
export { ForwardRef as ReactComponent };